import { BaseClient } from '../client';
import { TRevenda, shopkeeperMock } from '../shopkeeper';


export const getAllBuyers = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return shopkeeperMock;
	// }

	try {
		const response = await BaseClient.get<TRevenda[]>(`/Admin/GetAdminRevendas`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
